"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyledImage = exports.CarouselItem = exports.StyledCarouselImage = exports.StyledCarousel = exports.StyledContentContainer = exports.StyledIndicator = exports.StyledIndicatorsContainer = exports.StyledCarouselContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = require("../Icon");

var _colors = require("../../utils/colors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  transform: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n\n  @media screen and (min-width: ", ") {\n    display: none;\n  }\n\n  & > svg {\n    cursor: pointer;\n\n    path {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  align-self: flex-start;\n  @media screen and (min-width: ", ") {\n    transform-origin: bottom center;\n    transition: all 0.2s ease-in-out;\n    cursor: pointer;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 165px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  &:nth-of-type(", ") {\n    & > ", ":after {\n      box-sizing: border-box;\n      opacity: 1;\n      content: '';\n      position: absolute;\n      width: 100%;\n      height: 4px;\n      bottom: -1px;\n      left: 0;\n      right: 0;\n      border-radius: 10px;\n      background-color: ", ";\n      z-index: 2;\n    }\n  }\n\n  @media screen and (min-width: ", ") {\n    width: 182px;\n  }\n\n  @media screen and (min-width: ", ") {\n    padding: 2rem 0;\n\n    &:not(:nth-last-of-type(1)) {\n      margin-right: 6rem;\n    }\n\n    &:nth-of-type(", ") {\n      & img,\n      & > ", ":after {\n        opacity: 1;\n        transform: scale(1.2);\n      }\n    }\n\n    &:nth-of-type(1) > ", ":before {\n      content: '';\n      position: absolute;\n      width: 760px;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      border: 1px solid ", ";\n      z-index: 1;\n    }\n  }\n\n  @media screen and (min-width: ", ") {\n    &:not(:nth-last-of-type(1)) {\n      margin-right: 8rem;\n    }\n\n    &:nth-of-type(1) > ", ":before {\n      width: 845px;\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 165px;\n  max-height: 250px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n\n  @media screen and (min-width: ", ") {\n    width: 182px;\n    max-height: 300px;\n  }\n\n  @media screen and (min-width: ", ") {\n    max-height: unset;\n\n    & > * {\n      opacity: 0.8;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  width: ", ";\n  transform: translate(", ");\n  transition: transform 0.25s ease-in-out;\n  box-sizing: border-box;\n  padding: 1.5rem 0;\n\n  /* set child width */\n  & > * {\n    width: 100%;\n  }\n\n  @media screen and (min-width: ", ") {\n    & > * {\n      transition: all 0.2s ease-in-out;\n      cursor: pointer;\n    }\n  }\n\n  @media screen and (min-width: ", ") {\n    justify-content: center;\n    transform: unset;\n    transition: unset;\n  }\n\n  @media screen and (min-width: ", ") {\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 3rem;\n  width: 165px;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  @media screen and (min-width: ", ") {\n    width: 182px;\n  }\n\n  @media screen and (min-width: ", ") {\n    width: 830px;\n    display: flex;\n    align-items: center;\n  }\n\n  @media screen and (min-width: ", ") {\n    width: 1100px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 1px solid ", ";\n  cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  & > div:not(:nth-last-of-type(1)) {\n    margin-right: 2.25rem;\n  }\n\n  @media screen and (min-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledCarouselContainer = _styledComponents.default.div(_templateObject());

exports.StyledCarouselContainer = StyledCarouselContainer;

var StyledIndicatorsContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.breakpoints.md;
});

exports.StyledIndicatorsContainer = StyledIndicatorsContainer;

var StyledIndicator = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.active && props.theme.colors.actionPrimary300 || 'transparent';
}, function (props) {
  return props.theme.colors.actionPrimary300;
}); // Visible part of the Carousel


exports.StyledIndicator = StyledIndicator;

var StyledContentContainer = _styledComponents.default.div(_templateObject4(), function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.lg;
}); // Actual carousel with images in a row


exports.StyledContentContainer = StyledContentContainer;

var StyledCarousel = _styledComponents.default.div(_templateObject5(), function (props) {
  return "".concat(props.childCount * 100, "%");
}, function (props) {
  return "".concat(props.moveBy, "%");
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.lg;
});

exports.StyledCarousel = StyledCarousel;

var StyledCarouselImage = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.md;
});

exports.StyledCarouselImage = StyledCarouselImage;

var CarouselItem = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.currentChild;
}, StyledCarouselImage, function (props) {
  return props.theme.colors.actionPrimary300;
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.currentChild;
}, StyledCarouselImage, StyledCarouselImage, function (props) {
  return props.theme.colors.brandThemeLight300;
}, function (props) {
  return props.theme.breakpoints.lg;
}, StyledCarouselImage);

exports.CarouselItem = CarouselItem;

var StyledImage = _styledComponents.default.img(_templateObject8(), function (props) {
  return props.theme.breakpoints.md;
}); // Previous and Next arrow icons container


exports.StyledImage = StyledImage;
var StyledIcon = (0, _styledComponents.default)(_Icon.Icon)(_templateObject9(), function (props) {
  return props.previous && "rotate(90deg)" || "rotate(-90deg)";
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.carousel.iconColor, props.theme);
});
exports.StyledIcon = StyledIcon;